import styled from 'styled-components'

export const SelectContainer = styled.div`
  position: relative;
  width: 200px;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  border-radius: 12px;
  border: 1px solid #8a8a8a;
  ${(props) => props.theme.content};
  color: #8a8a8a;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const SelectInput = styled.input`
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  background: transparent;
  color: ${(props) => props.theme.textColor};
  font-size: 1rem;
`

export const SelectOptionsContainer = styled.div`
  position: fixed;
  left: 0;
  width: fit-content;
  max-height: 200px;
  background: ${(props) => props.theme.appBackground};
  color: ${(props) => props.theme.textColor};
  border: 1px solid #8a8a8a;
  border-radius: 12px;
  z-index: 100;
  overflow-y: auto;

  // overflow scrollbar
  &::-webkit-scrollbar {
    display: none;
  }
  & {
    scrollbar-width: none;
  }
  & {
    -ms-overflow-style: none;
  }
`

export const SelectOption = styled.div<{ active?: boolean }>`
  padding: 8px;
  cursor: pointer;
  color: ${(props) => (props.active ? props.theme.colorOrange : props.theme.textColor)};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  &:hover {
    background: ${(props) => props.theme.inputActiveBackground};
  }
`

export const SelectLabel = styled.div`
  color: ${(props) => props.theme.textColor};
  position: absolute;
  line-height: 2.5rem;
  top: 0;
  bottom: 0;
  left: 16px;
  right: 40px;
  z-index: 100;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-block: auto;
`

export const ChevronIconContainer = styled.div`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  height: 1.5rem;
  color: ${(props) => props.theme.textColor};
`

export const MultiSelectFieldWrapper = styled.div<{ invalid?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  max-width: 100%;
  overflow: hidden;
  min-width: 0;

  width: 100%;
  border: 1px solid ${(props) => props.theme.tableRowBorder};
  border-radius: 12px;
  padding: 0.5rem 1rem;
  padding-right: 2.5rem;
  background: #22202080;

  min-height: 44px;
  cursor: text;

  &:focus-within {
    border: 1px solid ${(props) => props.theme.colorOrange};
  }

  ${(props) =>
    props.invalid &&
    `
    border: 1px solid ${props.theme.colorRed};
  `}
`

export const MultiSelectInput = styled.input`
  border: none;
  outline: none;
  min-width: 0;
  width: 0;
  flex: 1 1 150px;
  background: transparent;
  color: ${(p) => p.theme.textColor};
  font-size: 1rem;
`

export const Pill = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 999px;
  background: ${(p) => p.theme.colorOrange}20;
  color: ${(p) => p.theme.colorOrange};
  font-size: 0.85rem;
`

export const Remove = styled.span`
  cursor: pointer;
`
